import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useState } from "react";
import { useMutation } from '@tanstack/react-query';
import { LinkLocation } from "@/modules/lead-page/api/lead-page.api";
import { LocationTypes } from "@/modules/lead-page/types";
import { LinkLocationRequest } from "@/modules/lead-page/dtos";
import { queryClient } from "@/queryClient";
import useLocationsData from "@/modules/common/hooks/locations-data.hook";
import { UUID } from "crypto";

const useEditLocation = () => {
  const { lead } = useContext(LeadPageContext);

  const [selectedLocation, setSelectedLocation] = useState<{
    label: string;
    uid: UUID | string;
    id: number;
    locationType: string;
  } | null>(null);

  const [locationType, setLocationType] = useState<LocationTypes | "">("");

  const [linkLocationModal, setlinkLocationModal] = useState(false);

  const [editLocationModalOpen, setEditLocationModalOpen] = useState(false);

  const {
    locationsError,
    locationsLoading,
    locationSearchTerm,
    locationsData,
    setLocationsSearchTerm,
    handleSearchChange,
  } = useLocationsData();

  const linkLocation = useMutation(
    (data: LinkLocationRequest) => LinkLocation(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["getLead"] });

        queryClient.invalidateQueries({
          queryKey: ["lead-compound"],
        });
      },
    }
  );
  const handleLinkLocation = () => {
    const linkLocationRequest: LinkLocationRequest | undefined =
      selectedLocation?.uid && locationType && lead?.data?.lead?.location
        ? {
            location_id: selectedLocation.uid,
            location_name: lead.data.lead.location.name,
            location_type: locationType,
          }
        : undefined;

    if (linkLocationRequest) {
      linkLocation.mutate(linkLocationRequest);
    }
    setlinkLocationModal(false);
    setSelectedLocation(null);
    setLocationType("");
  };

  return {
    location: {
      editLocationModalOpen,
      setEditLocationModalOpen,
      setSelectedLocation,
      selectedLocation,
      value: lead?.data?.lead?.location.name
        ? lead?.data?.lead?.location.name
        : "Not Set",

      location: selectedLocation,
      setState: setSelectedLocation,
      locationSearchTerm,
      handleSearchChange,
      setLocationsSearchTerm,
      locationsData,
      locationsError,
      locationsLoading,
    },
    locationType,
    selectedLocation,
    linkLocationModal,
    isLoading: linkLocation.isLoading,
    isError: linkLocation.isError,
    isSuccess: linkLocation.isSuccess,
    setLocationType,
    handleLinkLocation,
    setSelectedLocation,
    setlinkLocationModal,
  };
};

export default useEditLocation;
